document.addEventListener("DOMContentLoaded", function () {
  let galleryElements = document.querySelector(".carousel-gallery");
  if (galleryElements) {
    let gallerySplide = new Splide(".splide.carousel-gallery", {
      type: "loop",
      perPage: 3,
      autoplay: true,
      interval: 3000,
      arrows: false,
      pagination: true,
      gap: "1em",
      breakpoints: {
        576: {
            perPage: 1,
          },
          768: {
            perPage: 2,
          },
          992: {
            perPage: 3,
          },
      },
    });

    gallerySplide.mount();
        // Move to previous slide (-1)
        document.querySelector(".custome_splide__arrow--prev").addEventListener("click", function () {
            gallerySplide.go("-1"); // Moves one slide back
        });

        // Move to next slide (+1)
        document.querySelector(".custome_splide__arrow--next").addEventListener("click", function () {
            gallerySplide.go("+1"); // Moves one slide forward
        });
  }

  document.querySelectorAll(".carousel-project-gallery").forEach((projectGalleryElement, index) => {
    let gallerySplide = new Splide(projectGalleryElement, {
      type: "loop",
      perPage: 1,
      autoplay: true,
      interval: 3000,
      arrows: false,
      pagination: true,
      gap: "1em",
    });
  
    gallerySplide.mount();
  
    // Scoped query: only search inside the current projectGalleryElement
    const prevBtn = projectGalleryElement.querySelector(".custome_splide__arrow--prev");
    const nextBtn = projectGalleryElement.querySelector(".custome_splide__arrow--next");
  
    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        gallerySplide.go("-1");
      });
    }
  
    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        gallerySplide.go("+1");
      });
    }
  });

  const homeServiceGalleries = document.querySelectorAll(
    ".carousel-home-gallery"
  );
  if (homeServiceGalleries) {
    homeServiceGalleries.forEach(function (splideElement) {
      new Splide(splideElement, {
        type: "loop",
        perPage: 1,
        autoplay: true,
        interval: 3000,
        arrows: false,
        pagination: false,
        breakpoints: {
          1024: { perPage: 1 },
          768: { perPage: 1 },
        },
      }).mount();
    });
  }

  let credibilityElement = document.querySelector(".splide.credibility_slider");

  if (credibilityElement) {
    let autoSlideAttr = credibilityElement.getAttribute("data-auto");
    let perPageAttr = credibilityElement.getAttribute("data-perPage");
    let autoSlide = autoSlideAttr.trim().toLowerCase() === "true";
    let perPageLg = Math.floor(perPageAttr.trim());
    let perPageMd = Math.max(Math.floor(perPageLg / 2), 3);
    let perPageSm = Math.max(Math.floor(perPageLg / 3), 2);

    let credibilitySplide = new Splide(".splide.credibility_slider", {
      type: "loop",
      perPage: 4,
      arrows: false,
      pagination: false,
      gap: "1em",
      autoScroll: { speed: 1, pauseOnHover: false },

      fixedHeight: 100,
      mediaQuery: "min",
      // autoplay: true,
      // focus:"center",
      // interval: 10000,
      breakpoints: {
        576: {
          perPage: perPageSm,
        },
        768: {
          perPage: perPageMd,
        },
        992: {
          perPage: perPageLg,
        },
      },
    });

    credibilitySplide.mount(autoSlide ? window.splide.Extensions : "");
  }
});
